<h1 mat-dialog-title>
    {{ data.title }}
</h1>

<div mat-dialog-content>
    <ng-container *ngIf="data['metadata']">
        <form fxLayout="column" fxLayoutGap="1vh" [formGroup]="form">
            <!-- <mat-form-field fxFlex [hidden]="noteTypesEnumList.length == 0"> -->
            <mat-form-field fxFlex [hidden]="true">
                <mat-label>{{'Type' | translate}}</mat-label>
                <mat-select formControlName="noteType" (selectionChange)="onNoteTypeChange($event.value)">
                    <mat-option *ngFor="let type of noteTypesEnumList" [value]="type.value">{{type.label |
                        translate}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field fxFlex>
                <mat-label>{{'Title' | translate}}</mat-label>
                <input matInput [maxlength]="metadata.get('name').charlimit" formControlName="title" />
                <mat-error *ngIf="!form.controls.title.valid">
                    {{'Title' | translate}} {{'is required' | translate}}
                </mat-error>
            </mat-form-field>
            <mat-form-field fxFlex>
                <mat-label>{{'Remarks' | translate}}</mat-label>
                <textarea matInput rows="5" [maxlength]="metadata.get('notes').charlimit"
                    [placeholder]="'Remarks' | translate" formControlName="description"></textarea>
            </mat-form-field>
            <mat-form-field fxFlex *ngIf="isThreatType() && metadata.get('threat_type') && !data.note?._id">
                <mat-label>{{ metadata.get('threat_type')?.displayName || ('Incident Type' | translate) }}</mat-label>
                <mat-select formControlName="threat_type">
                    <mat-option *ngFor="let opt of metadata.get('threat_type').enum" [value]="opt.value">
                        {{ opt.displayName }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="form.controls.threat_type.invalid">
                    {{ 'Incident Type' | translate }} {{ 'is required' | translate }}
                </mat-error>
            </mat-form-field>
            <mat-form-field fxFlex *ngIf="isThreatType() && data.note?._id && threatTypesEnumForEdit?.length">
                <mat-label>{{ metadata.get('threat_types')?.displayName || ('Incident Types' | translate) }}</mat-label>
                <mat-select formControlName="threat_types" multiple>
                    <mat-option *ngFor="let opt of threatTypesEnumForEdit" [value]="opt.value">
                        {{ opt.displayName }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="form.controls.threat_types?.invalid">
                    {{ 'Incident Types' | translate }} {{ 'is required' | translate }}
                </mat-error>
            </mat-form-field>
            <ng-container *ngIf="data.note?.type == 'alert'">
                <mat-form-field fxFlex>
                    <mat-label>{{'Alert Sent To' | translate}}</mat-label>
                    <input matInput formControlName="alertSentTo" readonly />
                </mat-form-field>
            </ng-container>
            <ng-container *ngIf="data.note?.type != 'location' && data.type != 'LPR'">
                <!-- <mat-form-field fxFlex>
                <mat-label>{{'Add Materials' | translate}}</mat-label>
                <mat-select formControlName="selectedType">
                    <mat-option value="audio">{{'Audio' | translate}}</mat-option>
                    <mat-option value="image">{{'Image' | translate}}</mat-option>
                    <mat-option value="file">{{'File' | translate}}</mat-option>
                    <mat-option value="video">{{'Video' | translate}}</mat-option>
                    <mat-option value="camera">{{'Camera' | translate}}</mat-option>
                </mat-select>
            </mat-form-field> -->
                <!-- <ng-container *ngIf="form.controls.selectedType.value && data.note?.type != 'annotation'">
                <div align="right" class="add-doc" *ngIf="form.controls.selectedType.value != 'camera'">
                    {{uploadFileLabelDisplayName}} <mat-icon (click)="upload()">add_circle</mat-icon>
                </div>
                <mat-form-field fxFlex>
                    <mat-label>{{titleDisplayName}}</mat-label>
                    <mat-select formControlName="document" *ngIf="form.controls.selectedType.value != 'camera'">
                        <mat-option *ngFor="let doc of docs" [value]="doc._id">{{doc.name}}</mat-option>
                    </mat-select>
                    <mat-select formControlName="camera" *ngIf="form.controls.selectedType.value == 'camera'">
                        <mat-option *ngFor="let camera of cameras" [value]="camera._id">{{camera.name}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </ng-container>-->
            </ng-container>
            <ng-container *ngIf="data.note?.type != 'location' && data.type != 'LPR'">
                <!-- <mat-form-field fxFlex>
                <mat-label>{{'Add Materials' | translate}}</mat-label>
                <mat-select multiple formControlName="selectedTypes">
                    <mat-option value="audio">{{'Audio' | translate}}</mat-option>
                    <mat-option value="image">{{'Image' | translate}}</mat-option>
                    <mat-option value="file">{{'File' | translate}}</mat-option>
                    <mat-option value="video">{{'Video' | translate}}</mat-option>
                    <mat-option value="camera">{{'Camera' | translate}}</mat-option>
                </mat-select>
            </mat-form-field>
            <ng-container *ngIf="form.controls.selectedTypes.value?.length && data.note?.type != 'annotation'">
                <ng-container *ngFor="let type of form.controls.selectedTypes.value">
                    <div align="right" class="add-doc" *ngIf="type !='camera'">
                        {{'Add' | translate}} {{titleDisplayNameMap[type] | translate}} <mat-icon (click)="uploads(type)">add_circle</mat-icon>
                      </div>
                  <mat-form-field fxFlex *ngIf="type !== 'camera'">
                    <mat-label>{{ titleDisplayNameMap[type] || 'Document'  | translate}}</mat-label>
                    <mat-select multiple [formControlName]="getFormControlName(type)">
                      <mat-option *ngFor="let doc of getDocsByType(type)" [value]="doc._id">{{doc.name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
              
                  <mat-form-field fxFlex *ngIf="type === 'camera'">
                    <mat-label>{{ 'Camera' | translate}}</mat-label>
                    <mat-select multiple formControlName="cameras">
                      <mat-option *ngFor="let camera of cameras" [value]="camera._id">{{camera.name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
              
                </ng-container>
              
              </ng-container> -->
                <ng-container *ngIf="data.note?.type != 'annotation'">
                    <mat-form-field fxFlex class="attachments-select-field">
                        <mat-label>{{ 'Attachments' | translate}}</mat-label>
                        <mat-select multiple formControlName="documents">
                            <mat-option *ngFor="let doc of docs" [value]="doc._id">{{doc.name}}</mat-option>
                        </mat-select>
                        <button mat-icon-button matSuffix type="button" class="manage-attachments-btn"
                            (click)="$event.stopPropagation(); manageAttachments()"
                            [disabled]="isReadOnlyTimelineNote()"
                            [matTooltip]="'Manage Attachments' | translate" matTooltipPosition="above">
                            <mat-icon>attach_file</mat-icon>
                        </button>
                    </mat-form-field>
                    <mat-form-field fxFlex
                        *ngIf="mainNoteType !== 'personOfInterest' && mainNoteType !== 'carOfInterest' && (data.subType !== 'threat' || data.note?._id)">
                        <mat-label>{{ 'Cameras' | translate}}</mat-label>
                        <mat-select multiple formControlName="cameras">
                            <mat-option *ngFor="let camera of cameras" [value]="camera._id"
                                [disabled]="isInvestigator && camera.invisible && (!currentUserMap || !currentUserMap.timeline_visibility || currentUserMap.timeline_visibility === '' || currentUserMap.timeline_visibility === 'filtered')">{{camera.name}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field fxFlex
                        *ngIf="mainNoteType !== 'personOfInterest' && mainNoteType !== 'carOfInterest' && data.subType === 'threat' && !data.note?._id">
                        <mat-label>{{ 'Camera' | translate}}</mat-label>
                        <mat-select [value]="threatCameraSingleId"
                            [disabled]="isReadOnlyTimelineNote()"
                            (selectionChange)="onThreatSingleCameraChange($event.value)">
                            <mat-option *ngFor="let camera of cameras" [value]="camera._id"
                                [disabled]="isInvestigator && camera.invisible && (!currentUserMap || !currentUserMap.timeline_visibility || currentUserMap.timeline_visibility === '' || currentUserMap.timeline_visibility === 'filtered')">{{camera.name}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="data.type != 'LPR' && !isThreatType()">
                <div fxFlex fxLayout="row" fxLayoutGap="1vw">
                    <mat-form-field fxFlex="50">
                        <mat-label>{{'Entry Date/Occurrence Date' | translate}}</mat-label>
                        <input matInput [matDatepicker]="dp" formControlName="actionDate">
                        <mat-hint>YYYY-MM-DD</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="dp"></mat-datepicker-toggle>
                        <mat-datepicker #dp></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field fxFlex>
                        <mat-label>{{'Entry Time/Occurrence Time' | translate}}</mat-label>
                        <input matInput [ngxTimepicker]="picker" formControlName="actionTime" [format]="24">
                        <ngx-material-timepicker #picker [cancelBtnTmpl]="cancelBtnTmpl"
                            [confirmBtnTmpl]="confirmBtnTmpl"></ngx-material-timepicker>
                    </mat-form-field>
                    <ng-template #cancelBtnTmpl>
                        <button class="red-text" mat-raised-button style="margin-left: 16px;">
                            {{'Cancel' | translate}}
                        </button>
                    </ng-template>
                    <ng-template #confirmBtnTmpl>
                        <button class="green-text" mat-raised-button>
                            {{'OK' | translate}}
                        </button>
                    </ng-template>
                </div>
                <div fxLayout="row" fxFlex fxLayoutGap="1vw">
                    <!-- <mat-form-field fxFlex="50">
                    <mat-label>{{'Type of Interest' | translate}}</mat-label>
                    <mat-select formControlName="interest">
                        <mat-option [value]="">{{'None' | translate}}</mat-option>
                        <mat-option [value]="'person'">{{'Person' | translate}}</mat-option>
                        <mat-option [value]="'car'">{{'Car' | translate}}</mat-option>
                    </mat-select>
                </mat-form-field> -->
                    <mat-form-field fxFlex *ngIf="data.subType == 'personOfInterest'">
                        <mat-label>{{'Name or Designation' | translate}}</mat-label>
                        <input type="text" matInput maxlength="150" formControlName="personOfInterestName"
                            [matAutocomplete]="person">
                        <mat-autocomplete autoActiveFirstOption #person="matAutocomplete"
                            (optionSelected)="onPersonSelection($event)">
                            <mat-option *ngFor="let person of filteredPeople" [value]="person.person_of_interest_name">
                                {{person.person_of_interest_name}}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                    <mat-form-field fxFlex *ngIf="data.subType == 'carOfInterest'">
                        <mat-label>{{'Plate Number'| translate}}</mat-label>
                        <input type="text" maxlength="150" matInput formControlName="plateOfInterest"
                            [matAutocomplete]="plate">
                        <mat-autocomplete autoActiveFirstOption #plate="matAutocomplete"
                            (optionSelected)="onCarSelection($event)">
                            <mat-option *ngFor="let plate of filteredPlates" [value]="plate.plate_of_interest">
                                {{plate.plate_of_interest}}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-hint *ngIf="_locale === 'ja'">{{'Half-width' | translate}}</mat-hint>
                        <!-- <mat-error
                        *ngIf="!form.controls.plateOfInterest.value && !form.controls.plateOfInterestIdentifier.value">
                        {{'Plate Number or Car Identifier should be filled | translate}}
                    </mat-error> -->
                    </mat-form-field>
                </div>
                <ng-container *ngIf="data.subType == 'personOfInterest'">
                    <!-- <mat-form-field fxFlex>
                    <mat-label>{{'Name or Designation' | translate}}</mat-label>
                    <input matInput formControlName="personOfInterestName"
                        [maxlength]="metadata.get('person_of_interest_name').charlimit">
                </mat-form-field> -->
                    <div fxLayout="row" fxLayoutGap="1vw" fxFlex>
                        <mat-form-field fxFlex>
                            <mat-label>{{'DOB' | translate}}</mat-label>
                            <input matInput [matDatepicker]="dobPicker" formControlName="personOfInterestDOB">
                            <mat-datepicker-toggle matIconSuffix [for]="dobPicker"></mat-datepicker-toggle>
                            <mat-datepicker #dobPicker></mat-datepicker>
                        </mat-form-field>
                        <mat-form-field fxFlex>
                            <mat-label>{{'Approximate age' | translate}}</mat-label>
                            <input matInput type="number" formControlName="personOfInterestApproximateAge">
                        </mat-form-field>
                    </div>
                    <div fxLayout="row" fxLayoutGap="1vw" fxFlex>
                        <mat-form-field fxFlex>
                            <mat-label>{{'Gender' | translate}}</mat-label>
                            <mat-select formControlName="personOfInterestGender">
                                <mat-option *ngFor="let gender of metadata.get('person_of_interest_gender').enum"
                                    [value]="gender.value">
                                    {{gender.displayName}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field fxFlex *ngIf="metadata.get('person_of_interest_hair_color')">
                            <mat-label>{{'Hair color' | translate}}</mat-label>
                            <mat-select formControlName="personOfInterestHairColor">
                                <mat-option *ngFor="let color of metadata.get('person_of_interest_hair_color').enum"
                                    [value]="color.value">
                                    {{color.displayName}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <mat-form-field fxFlex *ngIf="form.controls.personOfInterestGender.value === 'other'">
                        <mat-label>{{'Other gender' | translate}}</mat-label>
                        <input matInput maxlength="150" formControlName="personOfInterestGenderOther">
                    </mat-form-field>
                    <div fxLayout="row" fxLayoutGap="1vw" fxFlex>
                        <mat-form-field fxFlex>
                            <mat-label>{{'Height' | translate}}</mat-label>
                            <input matInput type="number" formControlName="personOfInterestHeight">
                        </mat-form-field>
                        <mat-form-field fxFlex>
                            <mat-label>{{'Weight' | translate}}</mat-label>
                            <input matInput type="number" formControlName="personOfInterestWeight">
                        </mat-form-field>
                    </div>
                    <div fxLayout="row" fxLayoutGap="1vw" fxFlex>
                        <mat-form-field fxFlex *ngIf="metadata.get('person_of_interest_eye_color')">
                            <mat-label>{{'Eye color' | translate}}</mat-label>
                            <mat-select formControlName="personOfInterestEyeColor">
                                <mat-option *ngFor="let eyeColor of metadata.get('person_of_interest_eye_color').enum"
                                    [value]="eyeColor.value">
                                    {{eyeColor.displayName}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field fxFlex *ngIf="metadata.get('person_of_interest_race')">
                            <mat-label>{{'Race' | translate}}</mat-label>
                            <mat-select formControlName="personOfInterestRace">
                                <mat-option *ngFor="let race of metadata.get('person_of_interest_race').enum"
                                    [value]="race.value">
                                    {{race.displayName}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <mat-form-field fxFlex>
                        <mat-label>{{'Distinguishing features' | translate}}</mat-label>
                        <input matInput maxlength="150" formControlName="personOfInterestDistinguishingFeatures">
                    </mat-form-field>
                    <mat-form-field fxFlex>
                        <mat-label>{{'Profile' | translate}}</mat-label>
                        <input matInput formControlName="personOfInterestDescription"
                            [maxlength]="metadata.get('person_of_interest_description').charlimit">
                    </mat-form-field>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="data.subType == 'carOfInterest' || data.type == 'LPR'">
                <mat-form-field fxFlex *ngIf="data.type == 'LPR'">
                    <mat-label>{{'Plate Number'| translate}}</mat-label>
                    <input type="text" maxlength="150" matInput formControlName="plateOfInterest"
                        [matAutocomplete]="plate">
                    <mat-autocomplete autoActiveFirstOption #plate="matAutocomplete"
                        (optionSelected)="onCarSelection($event)">
                        <mat-option *ngFor="let plate of filteredPlates" [value]="plate.plate_of_interest">
                            {{plate.plate_of_interest}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                <mat-form-field fxFlex>
                    <mat-label>{{'Car Identifier'| translate}}</mat-label>
                    <input matInput formControlName="plateOfInterestIdentifier"
                        [maxlength]="metadata.get('car_of_interest_identifier').charlimit">
                    <!-- <mat-error
                    *ngIf="!form.controls.plateOfInterest.value && !form.controls.plateOfInterestIdentifier.value">
                    {{'Plate Number or Car Identifier should be filled | translate}}
                </mat-error> -->
                </mat-form-field>
                <mat-form-field fxFlex>
                    <mat-label>{{'Car Description' | translate}}</mat-label>
                    <input matInput formControlName="plateOfInterestDescription"
                        [maxlength]="metadata.get('car_of_interest_description').charlimit">
                </mat-form-field>
                <ng-container *ngIf="data.subType == 'carOfInterest'">
                    <mat-form-field fxFlex>
                        <mat-label>{{'Car Type'| translate}}</mat-label>
                        <mat-select formControlName="carType">
                            <mat-option *ngFor="let type of metadata.get('car_type').enum" [value]="type.value">
                                {{ type.displayName }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field fxFlex>
                        <mat-label>{{'Car Make'| translate}}</mat-label>
                        <input type="text" [maxlength]="metadata.get('car_make').charlimit" matInput
                            formControlName="carMake" [matAutocomplete]="carMake">
                        <mat-autocomplete autoActiveFirstOption #carMake="matAutocomplete"
                            (optionSelected)="onCarMakeSelection($event)">
                            <mat-option *ngFor="let make of filteredCarMakes" [value]="make.car_make">
                                {{make.car_make}}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                    <mat-form-field fxFlex>
                        <mat-label>{{'Car Model'| translate}}</mat-label>
                        <input type="text" [maxlength]="metadata.get('car_model').charlimit" matInput
                            formControlName="carModel" [matAutocomplete]="carModel">
                        <mat-autocomplete autoActiveFirstOption #carModel="matAutocomplete"
                            (optionSelected)="onCarModelSelection($event)">
                            <mat-option *ngFor="let model of filteredCarModels" [value]="model.car_model">
                                {{model.car_model}}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </ng-container>
                <mat-form-field fxFlex>
                    <mat-label>{{'Car Color'| translate}}</mat-label>
                    <mat-select formControlName="carColor">
                        <mat-option *ngFor="let color of metadata.get('car_color').enum" [value]="color.value">
                            {{color.displayName}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </ng-container>
            <ng-container *ngIf="data.type != 'LPR'">
                <mat-form-field fxFlex *ngIf="!isThreatType()">
                    <mat-label>{{'Investigators' | translate}}</mat-label>
                    <mat-select formControlName="investigators" multiple>
                        <mat-option *ngFor="let investigator of investigators"
                            [value]="investigator._id">{{investigator.alternative_name ? investigator.alternative_name :
                            investigator.name}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field fxFlex *ngIf="!isThreatType()">
                    <mat-label>{{'Investigator Groups' | translate}}</mat-label>
                    <mat-select formControlName="investigatorGroups" multiple>
                        <mat-option *ngFor="let group of investigatorGroups"
                            [value]="group._id">{{group.name}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <ng-container *ngIf="data.note?.type != 'status'">
                    <mat-form-field fxFlex>
                        <mat-label>{{'Address' | translate}}</mat-label>
                        <input matInput formControlName="address" (keydown.enter)="searchAddress()" />
                        <mat-icon matSuffix [style.cursor]="isReadOnlyTimelineNote() ? 'default' : 'pointer'"
                            [class.disabled]="isReadOnlyTimelineNote()" (click)="searchAddress()">travel_explore</mat-icon>
                    </mat-form-field>
                    <div fxFlex style="min-height: 45vh;"
                        [style.pointer-events]="isReadOnlyTimelineNote() ? 'none' : null">
                        <mat-label>{{'Location' | translate}}</mat-label>
                        <app-smart-map #timelineMap [height]="'45vh'" (mapSelect)="markerMapSelect($event)"
                            [addMyMarker]="false" [setGeoLocation]="noteLocation"
                            (addressPinData)="addressPinData($event)" [enableAddessOnClick]="true"
                            (addressJPPinData)="addressJPPinData($event)"
                            [changeCenter]="caseGeolocation"></app-smart-map>
                        <mat-checkbox formControlName="excludeFromMap" class="exclude-from-map-checkbox"
                            *ngIf="data.note?._id || (data.subType != 'threat' && !data.note?._id)">
                            {{ 'Exclude from map' | translate }}
                        </mat-checkbox>
                    </div>
                </ng-container>
            </ng-container>
        </form>
    </ng-container>
</div>

<div mat-dialog-actions>
    <div fxLayout="row">
        <div fxFlex>
            <mat-icon class="delete" [matTooltip]="'Delete' | translate" (click)="delete()" [disabled]="!form.valid"
                *ngIf="form && data.note?._id && data.note.type != 'init' && data.note.type != 'status' && data.note.type != 'location'">delete</mat-icon>
        </div>
        <div fxFlex fxLayoutAlign="end">
            <!-- <button class="purple-text" mat-raised-button (click)="addAudioNote()"
                *ngIf="form && (!data.note?._id && !data.hideVoice && isSuperAdmin)">
                {{ "Voice Input" | translate }}
            </button> -->
            <button class="green-text" mat-raised-button (click)="save()" [disabled]="!form.valid"
                *ngIf="form && !data.note?._id && !isThreatType()">
                {{ "Create" | translate }}
            </button>
            <button class="green-text" mat-raised-button (click)="save()" [disabled]="!form.valid"
                *ngIf="form && !data.note?._id && isThreatType()">
                {{ "Proceed" | translate }}
            </button>
            <button class="green-text" mat-raised-button (click)="update()"
                [disabled]="form && (!form.valid || isReadOnlyTimelineNote())"
                *ngIf="data.note?._id">
                {{ "Update" | translate }}
            </button>
            <button class="red-text" mat-raised-button mat-dialog-close>
                {{ "Cancel" | translate }}
            </button>
        </div>
    </div>
</div>
